<div>
    <div *ngFor="let color of colors" (click)="selectColor(color)"
        [style.border]="selectedColor === color ? '2px solid goldenrod' : 'initial'" [style.backgroundColor]="color"
        [style.width.px]="selectedColor === color ? 40 : 30" [style.height.px]="selectedColor === color ? 40 : 30"
        [style.cursor]="!disabled && color !== selectedColor && (!deactivatedColors.includes(color) || color === initialColor) ? 'pointer' : 'default'"
        class="color-box">
        <mat-icon *ngIf="color !== initialColor && deactivatedColors.includes(color)" class="color-deactivated">close
        </mat-icon>
    </div>
</div>